import { CircleAlert } from "lucide-react";
import type { ReactNode } from "react";

export function FormField({
  label,
  hint,
  error,
  htmlFor,
  errorId,
  hintId,
  children,
}: {
  label: string;
  hint?: string;
  error?: string;
  /** Ties the label to its control, so clicking it focuses the field. */
  htmlFor?: string;
  /** Lets the control reference the rendered validation message. */
  errorId?: string;
  /** Lets the control reference the rendered hint. */
  hintId?: string;
  children: ReactNode;
}) {
  return (
    <div className="flex flex-col gap-2">
      <label htmlFor={htmlFor} className="flex items-center gap-2 text-[15px] font-medium">
        {label}
        {error ? <CircleAlert aria-hidden="true" size={16} className="shrink-0 text-destructive" /> : null}
      </label>
      {children}
      {error ? (
        <p id={errorId} className="sr-only">
          {error}
        </p>
      ) : null}
      {hint ? (
        <p id={hintId} className="text-sm text-muted-foreground">
          {hint}
        </p>
      ) : null}
    </div>
  );
}
